var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoT13(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 31,
    viewBox: "0 0 97 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_638_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 8.77206H54.2373V25H58.7529V8.77206H65V5H48V8.77206Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 8.71155H74.1684V25H79V5H70V8.71155Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0747 14.4643C94.1932 13.7004 92.9975 13.2242 91.518 12.996L96.0475 7.94643V5H81.9829V8.65079H90.5352L86.411 13.2341V16.2401H88.539C89.8562 16.2401 90.8189 16.4583 91.4066 16.8849C92.0044 17.3115 92.2983 17.9067 92.2983 18.6508C92.2983 19.4345 91.9639 20.0595 91.2951 20.506C90.6263 20.9524 89.7042 21.1806 88.539 21.1806C87.5054 21.1806 86.482 21.0218 85.4687 20.7044C84.4554 20.3869 83.5636 19.9504 82.8037 19.4147L81 22.8968C81.9525 23.5714 83.1279 24.0873 84.506 24.4544C85.8841 24.8214 87.2723 25 88.6707 25C90.5858 25 92.1564 24.7024 93.3825 24.0972C94.6086 23.502 95.5206 22.7183 96.1083 21.746C96.7061 20.7837 97 19.7421 97 18.6409C97 16.9345 96.3718 15.5357 95.1051 14.4544L95.0747 14.4643Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67542 4.62603H18.0212V12L22.2716 7.51236V4.62603H36.7895L40 0H0L2.67542 4.62603Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 13H31.4066L35 8H24.2402L20 13Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7282 13H23.7087L18 20.4731H24.3495L18 31H23.1068L32 16.4291H27.1748L29.7282 13Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6949 12.4915H11.2714V25.2425L16 31V8H5L7.6949 12.4915Z",
    fill: "#EAEAEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_638_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 31,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoT13);
export default __webpack_public_path__ + "static/media/logoT13.959c1938bd6f010f70eecf6f4ec22175.svg";
export { ForwardRef as ReactComponent };